import { render, staticRenderFns } from "./addLabel.vue?vue&type=template&id=70ce129e&scoped=true&"
import script from "./addLabel.vue?vue&type=script&lang=js&"
export * from "./addLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce129e",
  null
  
)

export default component.exports